export default __webpack_public_path__ + "static/docs-navigation-battery-d537f409dda6c6f34317d0c3d2f89c8f.jpg";